"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M10.71 3.072a3.488 3.488 0 0 0-4.198 3.416v.494a3.7 3.7 0 0 0-2.39 3.462V13.3a3.7 3.7 0 0 0 3.7 3.7h4.356a3.7 3.7 0 0 0 3.7-3.7v-2.856q0-.33-.055-.642a4.5 4.5 0 0 1-1.388.197q.042.216.043.445V13.3a2.3 2.3 0 0 1-2.3 2.3H7.822a2.3 2.3 0 0 1-2.3-2.3v-2.856a2.3 2.3 0 0 1 2.3-2.3h3.036a4.5 4.5 0 0 1-.684-1.4H7.912v-.256a2.09 2.09 0 0 1 2.222-2.084 4.49 4.49 0 0 1 .576-1.332"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.006 11.157c0 .286-.117.544-.306.729v1.678a.7.7 0 1 1-1.4 0v-1.678a1.02 1.02 0 0 1-.305-.73c0-.56.45-1.015 1.005-1.015a1.01 1.01 0 0 1 1.005 1.016"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.5 2.55a.7.7 0 0 1 .7.7V4.8h1.55a.7.7 0 0 1 0 1.4H15.2v1.55a.7.7 0 1 1-1.4 0V6.2h-1.55a.7.7 0 1 1 0-1.4h1.55V3.25a.7.7 0 0 1 .7-.7",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=LockAddIcon20.js.map